import { useTranslation } from 'react-i18next';
import { useParams, Navigate } from 'react-router-dom';
import { AppShell } from '@/components/layout/AppShell';
import { PageContainer } from '@/components/layout/PageContainer';
import { TopBar } from '@/components/layout/TopBar';
import { Card } from '@/components/ui/Card';
import { paths } from '@/routes/paths';

type PolicyKind = 'agreement' | 'privacy';

const ALLOWED: ReadonlySet<PolicyKind> = new Set(['agreement', 'privacy']);

function isPolicyKind(v: string | undefined): v is PolicyKind {
  return !!v && (ALLOWED as Set<string>).has(v);
}

export function SettingsPolicyViewPage(): JSX.Element {
  const { t } = useTranslation();
  const { kind } = useParams<{ kind: string }>();

  if (!isPolicyKind(kind)) {
    return <Navigate to={paths.settingsPolicies} replace />;
  }

  const titleKey = kind === 'agreement' ? 'settings.user_agreement' : 'settings.privacy_policy';
  const bodyKey = kind === 'agreement' ? 'policies.agreement_body' : 'policies.privacy_body';
  const updatedKey = 'policies.last_updated';

  return (
    <AppShell>
      <PageContainer>
        <TopBar back title={t(titleKey)} />
        <Card variant="light" padding="md">
          <div style={{ color: 'var(--color-text-on-light-muted)', fontSize: 12, marginBottom: 12 }}>
            {t(updatedKey)}
          </div>
          <div style={{ whiteSpace: 'pre-wrap', lineHeight: 1.5 }}>{t(bodyKey)}</div>
        </Card>
      </PageContainer>
    </AppShell>
  );
}
